import { useAppSelector } from '@verantos-dev/core-annotation-tool';

import { useGetAnnotationAgentSetupQuery } from '../../api/createProjectApiSlice';
import { useIsAgentStepEnabled } from '../../hooks/useCreateProjectWizardSteps';
import {
  selectAnnotationAgentConcepts,
  selectAnnotationAgentEnabled,
  selectAnnotationAgentModelId,
  selectAnnotationAgentSections,
} from '../../state/selector';

// TODO: cleanup with cp_annotation_createproject_agent ff
export interface ReviewAgentSummary {
  isOn: boolean;
  modelName: string | null;
  conceptCount: number;
  /** Names of the concepts with saved notes, in concept order. */
  conceptNamesWithNotes: string[];
  sectionHeadings: string[];
}

/** The Review "Annotation agent" section's data; null while the flag snapshot is off. */
// TODO: cleanup with cp_annotation_createproject_agent ff
export const useReviewAgentSummary = (): ReviewAgentSummary | null => {
  const isAgentStepEnabled = useIsAgentStepEnabled();
  const isOn = useAppSelector(selectAnnotationAgentEnabled);
  const modelId = useAppSelector(selectAnnotationAgentModelId);
  const concepts = useAppSelector(selectAnnotationAgentConcepts);
  const sections = useAppSelector(selectAnnotationAgentSections);
  // Step 5 already made this request, so the model list is cached; nothing is fetched while off.
  const { data: setup } = useGetAnnotationAgentSetupQuery(undefined, {
    skip: !isAgentStepEnabled || !isOn,
  });

  if (!isAgentStepEnabled) return null;

  const orderedConcepts = Object.values(concepts).sort((a, b) => a.sequence - b.sequence);
  return {
    isOn,
    modelName: setup?.data.models.find((model) => model.modelId === modelId)?.displayName ?? null,
    conceptCount: orderedConcepts.length,
    conceptNamesWithNotes: orderedConcepts
      .filter((concept) => concept.notes.trim() !== '')
      .map((concept) => concept.name),
    sectionHeadings: sections.map((section) => section.heading),
  };
};
